import { pollUnlessNotFound } from '../../../Utils/queryOptions';
import { useMutation, useQuery } from 'react-query';
import { newAccount } from '../../../API/TT_ELD/newAccount';

export const useApproval = (
  userName: string,
  userEmail: string,
  companyId: string | number,
  skip: string | number,
  isEmailVerified?: boolean,
) => {
  return useQuery(
    [`approvalUsers/${userName || 'all'}`, userName, userEmail, companyId, skip, isEmailVerified],
    () => newAccount.read(userName, userEmail, companyId, skip, isEmailVerified),
    { refetchOnWindowFocus: false, refetchInterval: (_data, query) => pollUnlessNotFound(query, 5 * 60 * 1000) },
  );
};
export const useUpdateUserStatus = (
  userName: string,
  userEmail: string,
  companyId: string | number,
  skip: string | number,
  registerStatus?: string,
) => {
  return useQuery(
    [`approvalUsers/${userName || 'all'}`, userName, userEmail, companyId, skip, registerStatus],
    () => newAccount.updateUserStatus(userName, userEmail, companyId, skip, registerStatus),
    { refetchOnWindowFocus: false, refetchInterval: (_data, query) => pollUnlessNotFound(query, 5 * 60 * 1000) },
  );
};
export const useApprovalCount = (): any => {
  return useQuery([`approvalCount/all`], () => newAccount.approvalCount(), {
    refetchOnWindowFocus: false,
    refetchInterval: (_data, query) => pollUnlessNotFound(query, 5 * 60 * 1000),
  });
};

export function useResendEmail() {
  return useMutation(({ payload }: { payload: { email: string } }) =>
    newAccount.resendEmail(payload),
  );
}

export function useUnreadEmailUsers() {
  return useQuery({
    queryKey: ['registered-users'],
    queryFn: newAccount.unReadEmail,
  });
}
